// assets/faq-ai.js
(function () {
  // === Config ===
  const API_BASE = "https://kinko-ia.vercel.app";   // ton domaine Vercel (sans slash final)
  const API_PATH = "/api/faq-ai";                   // route Next
  const BRAND = "#deb45c";                          // couleur Kinko
  const BOT_NAME = "Sempaï Kinko";

  // -------- Accroches variées (non répétées dans la session) --------
  const GREETINGS = [
    "Salut ! Comment puis-je t’aider ?",
    "Salut, Besoin d’un conseil produit ou compétition ?",
    "Salut, Dis-moi ce que tu cherches aujourd'hui (taille, niveau, objectif, etc.)",
    "Salut, Une question rapide ? Je te réponds.",
    "Salut, Je t’aide à trouver vite ce qu’il te faut.",
    "Salut, On y va pas à pas — que puis-je faire pour toi ?",
    "Salut, Règlements, tailles, prix… je t’aide."
  ];
  function pickGreeting() {
    try {
      const last = sessionStorage.getItem("faq-ai-last-greet-idx");
      const lastIdx = last == null ? -1 : parseInt(last, 10);
      let idx = Math.floor(Math.random() * GREETINGS.length);
      if (GREETINGS.length > 1 && idx === lastIdx) idx = (idx + 1) % GREETINGS.length;
      sessionStorage.setItem("faq-ai-last-greet-idx", String(idx));
      return GREETINGS[idx];
    } catch {
      return GREETINGS[Math.floor(Math.random() * GREETINGS.length)];
    }
  }

  // -- Helpers UI (sécuriser & lienifier) --
  function escapeHtml(s) {
    return s
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;");
  }

  // transforme [texte](https://url) + URLs brutes en <a>
  // IMPORTANT: on affiche **uniquement l’URL** comme texte du lien.
  function linkify(md) {
    let h = escapeHtml(md);

    // Markdown [text](url) -> <a href="url">url</a>
    h = h.replace(/\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g, (m, _txt, url) => {
      const safeUrl = escapeHtml(url);
      return `<a href="${safeUrl}" target="_blank" rel="noopener noreferrer">${safeUrl}</a>`;
    });

    // URLs brutes -> <a href="url">url</a>
    h = h.replace(/(?<!["'(\]])(https?:\/\/[^\s<)]+)/g, (url) => {
      const safeUrl = escapeHtml(url);
      return `<a href="${safeUrl}" target="_blank" rel="noopener noreferrer">${safeUrl}</a>`;
    });

    // retours à la ligne
    h = h.replace(/\n/g, "<br>");
    return h;
  }

  function addMessage(container, text, who) {
    const p = document.createElement("div");
    p.style.margin = "8px 0";
    p.innerHTML = `<b>${who}:</b> ${linkify(text)}`;
    container.appendChild(p);
    container.scrollTop = container.scrollHeight;
  }

  // === Bouton flottant ===
  const btn = document.createElement("button");
  btn.textContent = "Sempaï Kinko";
  Object.assign(btn.style, {
    position: "fixed",
    right: "16px",
    bottom: "16px",
    zIndex: 2147483647,
    padding: "10px 12px",
    borderRadius: "10px",
    border: "1px solid #ddd",
    background: BRAND,
    color: "#000",
    fontWeight: "600",
    cursor: "pointer",
    boxShadow: "0 6px 16px rgba(0,0,0,.15)",
  });
  document.body.appendChild(btn);

  // === Panneau ===
  const panel = document.createElement("div");
  panel.style.cssText =
    "position:fixed;right:16px;bottom:72px;width:360px;max-width:90vw;height:430px;background:#fff;border:1px solid #ddd;border-radius:12px;box-shadow:0 10px 30px rgba(0,0,0,.15);display:none;flex-direction:column;overflow:hidden;z-index:2147483647;font-family:system-ui,-apple-system,Segoe UI,Roboto,Ubuntu,Cantarell,Noto Sans,sans-serif;";
  panel.innerHTML = `
    <div style="padding:10px;border-bottom:1px solid #eee;font-weight:700;background:${BRAND};color:#000">
      Sempaï Kinko
    </div>
    <div id="faq-ai-log" style="padding:10px;flex:1;overflow:auto;font-size:14px;line-height:1.35"></div>
    <form id="faq-ai-form" style="display:flex;gap:6px;padding:10px;border-top:1px solid #eee">
      <input id="faq-ai-input" type="text" placeholder="Pose ta question…" style="flex:1;padding:8px;border:1px solid #ddd;border-radius:8px" />
      <button style="padding:8px 10px;border:1px solid #ddd;border-radius:8px;background:${BRAND};font-weight:600;cursor:pointer">Envoyer</button>
    </form>`;
  document.body.appendChild(panel);

  // Liens stylés dans la zone de log
  const log = panel.querySelector("#faq-ai-log");
  const style = document.createElement("style");
  style.textContent = `
    #faq-ai-log a { color: ${BRAND}; text-decoration: underline; }
    #faq-ai-log b { color: #222; }
  `;
  document.head.appendChild(style);

  // toggle + salutation à la 1re ouverture
  let greeted = false;
  const input = panel.querySelector("#faq-ai-input");
  btn.onclick = () => {
    const willOpen = panel.style.display === "none";
    panel.style.display = willOpen ? "flex" : "none";
    if (willOpen && !greeted) {
      addMessage(log, pickGreeting(), BOT_NAME);
      greeted = true;
      setTimeout(() => input && input.focus(), 120);
    }
  };

  // === Handling form ===
  const form = panel.querySelector("#faq-ai-form");
  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    const q = input.value.trim();
    if (!q) return;
    addMessage(log, q, "Toi");
    input.value = "";

    try {
      const r = await fetch(`${API_BASE}${API_PATH}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          q,
          lang: document.documentElement.lang?.slice(0, 2) || "fr",
        }),
      });

      const j = await r.json().catch(() => ({}));
      if (j?.answer) {
        addMessage(log, j.answer, BOT_NAME);
      } else if (j?.error) {
        addMessage(log, "Désolé, une erreur est survenue.", BOT_NAME);
        console.warn("FAQ AI error:", j.error);
      } else {
        addMessage(log, "Réponse introuvable.", BOT_NAME);
      }
    } catch (err) {
      addMessage(log, "Réseau indisponible.", BOT_NAME);
      console.warn(err);
    }
  });
})();
